<section class="cta-grid">
  <a class="cta-grid__tile" href="#/contact-us">
    <img class="cta-grid__bg cta-grid__bg--contact" src="assets/image/redesign/chezchoux-img1.jpg" i18n-alt="@@cta.contact.image.alt" alt="聯絡我們">
    <div class="cta-grid__overlay cta-grid__overlay--brown"></div>
    <div class="cta-grid__content">
      <div class="cta-grid__icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
      </div>
      <h3 class="cta-grid__title font-display" i18n="@@cta.contact.title">聯絡我們</h3>
      <p class="cta-grid__subtitle font-display" i18n="@@cta.contact.subtitle">Contact Us</p>
      <p class="cta-grid__body" i18n="@@cta.contact.body">歡迎查詢訂單、批發合作或任何問題</p>
      <span class="cta-grid__btn" i18n="@@cta.contact.button">聯絡我們</span>
    </div>
  </a>

  <a class="cta-grid__tile" href="#/store-locator">
    <img class="cta-grid__bg" src="assets/image/redesign/chezchoux-store.jpeg" i18n-alt="@@cta.shops.image.alt" alt="我們的分店">
    <div class="cta-grid__overlay cta-grid__overlay--grey"></div>
    <div class="cta-grid__content">
      <div class="cta-grid__icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      </div>
      <h3 class="cta-grid__title font-display" i18n="@@cta.shops.title">我們的分店</h3>
      <p class="cta-grid__subtitle font-display" i18n="@@cta.shops.subtitle">Our Shops</p>
      <p class="cta-grid__body" i18n="@@cta.shops.body">歡迎蒞臨我們的分店，親身體驗新鮮出爐的泡芙</p>
      <span class="cta-grid__btn" i18n="@@cta.shops.button">查看分店</span>
    </div>
  </a>
</section>
